// extracted by mini-css-extract-plugin
export default {"menu":"_5D3_tdKg"};